export const worksheets = {
  title: 'Worksheets',
  subtitle: 'Template-based worksheet management with digital signatures',
  new: 'New Worksheet',
  edit: 'Edit Worksheet',
  view: 'View Worksheet',
  delete: 'Delete Worksheet',
  
  // Status
  status: {
    draft: 'Draft',
    in_progress: 'In Progress',
    completed: 'Completed',
    cancelled: 'Cancelled'
  },
  
  // Work types
  workTypes: {
    installation: 'Installation',
    maintenance: 'Maintenance',
    repair: 'Repair',
    inspection: 'Inspection',
    other: 'Other'
  },
  
  // Priority
  priority: {
    low: 'Low',
    medium: 'Medium',
    high: 'High'
  },
  
  // Fields
  fields: {
    title: 'Worksheet Title',
    description: 'Description',
    customer: 'Customer',
    workType: 'Work Type',
    status: 'Status',
    priority: 'Priority',
    dueDate: 'Due Date',
    location: 'Location',
    workDetails: 'Work Details',
    materials: 'Materials',
    equipment: 'Equipment',
    safetyNotes: 'Safety Notes',
    estimatedHours: 'Estimated Hours',
    actualHours: 'Actual Hours',
    signatures: 'Signatures',
    documents: 'Documents'
  },
  
  // Actions
  actions: {
    create: 'Create',
    edit: 'Edit',
    view: 'View',
    delete: 'Delete',
    complete: 'Complete',
    sign: 'Sign',
    addSignature: 'Add Signature'
  },
  
  // Messages
  messages: {
    noWorksheets: 'No worksheets',
    noWorksheetsDescription: 'Get started by creating your first worksheet.',
    createSuccess: 'Worksheet created successfully',
    createError: 'Error creating worksheet',
    updateSuccess: 'Worksheet updated successfully',
    updateError: 'Error updating worksheet',
    deleteSuccess: 'Worksheet deleted successfully',
    deleteError: 'Error deleting worksheet',
    confirmDelete: 'Are you sure you want to delete this worksheet?',
    confirmTitle: 'Delete Worksheet',
    deleteQuestion: 'Are you sure you want to delete this worksheet?',
    deleteWarning: 'This action cannot be undone!',
    signatureAdded: 'Signature added successfully',
    signatureError: 'Error adding signature',
    completed: 'Worksheet completed',
    completedError: 'Error completing worksheet'
  },
  
  // Filters
  filters: {
    all: 'All',
    allTypes: 'All Types',
    byStatus: 'By Status',
    byType: 'By Type'
  }
}; 